import React, { useState, useContext, useEffect } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { DialogContentText, TextField } from "@material-ui/core";
import { useSnackbar } from "notistack";
import Context from "../../../../context";
import { postContent, updateContent, deleteDataTK } from "../../../../services";

export default function ModalTK({ data, open, onClose, action }: any) {
  const { enqueueSnackbar } = useSnackbar();
  const context = useContext(Context);
  const [loadingButtonState, setLoadingButtonState] = useState(false);
  const [formState, setFormState] = useState({
    title_id: "",
    title_en: "",
    place: "0",
  });

  const handleChangeForm = (e: any) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleActionTK = async () => {
    const body = new FormData();
    body.append("title_id", formState.title_id);
    body.append("title_en", formState.title_en);
    body.append("content_id", "-");
    body.append("content_en", "-");
    body.append("type", "16");
    body.append("place", formState.place + "");
    try {
      setLoadingButtonState(true);
      const res =
        action === "Add"
          ? await postContent(body)
          : await updateContent(data.id, body);
      setLoadingButtonState(false);
      if (res.status === "error") {
        enqueueSnackbar(res.message, {
          variant: "error",
        });
        return;
      }
      enqueueSnackbar(`Berhasil menambahkan data ${formState.title_id}`, {
        variant: "success",
      });
      onClose();
      setFormState(data);
    } catch (err: any) {
      setLoadingButtonState(false);
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    }
  };

  const handleDeleteTK = async () => {
    try {
      setLoadingButtonState(true);
      const res = await deleteDataTK(data.id);
      setLoadingButtonState(false);
      if (res.status === "error") {
        enqueueSnackbar(res.message, {
          variant: "error",
        });
        return;
      }
      context.closeDialog();
      enqueueSnackbar(`Berhasil menghapus data ${data.title_id}`, {
        variant: "success",
      });
      onClose();
      setFormState(data);
    } catch (err: any) {
      setLoadingButtonState(false);
      enqueueSnackbar(err.message, {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    setFormState(data);
  }, [data]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
    >
      <DialogTitle id="alert-dialog-title">{action} Teknologi Kami</DialogTitle>
      <DialogContent>
        {action === "Delete" && (
          <DialogContentText style={{ marginBottom: 24 }}>
            Apakah anda yakin ingin menghapus data {data.title_id} ?
          </DialogContentText>
        )}
        <TextField
          fullWidth
          label="No."
          variant="outlined"
          name="place"
          onChange={handleChangeForm}
          value={formState.place}
          style={{ marginBottom: 16 }}
          disabled={action === "Delete"}
        />
        <TextField
          fullWidth
          label="Title ID"
          variant="outlined"
          name="title_id"
          onChange={handleChangeForm}
          value={formState.title_id}
          style={{ marginBottom: 16 }}
          disabled={action === "Delete"}
        />
        <TextField
          fullWidth
          label="Title EN"
          name="title_en"
          onChange={handleChangeForm}
          value={formState.title_en}
          variant="outlined"
          disabled={action === "Delete"}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose();
            setFormState(data);
          }}
          color="primary"
        >
          Cancel
        </Button>
        <Button
          disabled={loadingButtonState}
          onClick={action !== "Delete" ? handleActionTK : handleDeleteTK}
          color="primary"
          autoFocus
        >
          {action !== "Delete" ? "Submit" : "Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
